import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import MoreVertical from '@icons/MoreVertical';
import { KiccCardRow } from '@models/easyCard/kicc';
import { getColorByIssuerCode } from '@models/easyCard/kicc/extension';
import { Link } from '@stackflow/link';

interface Props {
    easyCard: KiccCardRow;
}

function EasyCardItem({ easyCard }:Props) {
    const {
        cardId, cardNoSuffix, cardName, issuerCode,
    } = easyCard;
    const cardBackgroundColor = getColorByIssuerCode(issuerCode);
    return (
        <Container fullWidth spacing={3}>
            <CardIcon backgroundColor={cardBackgroundColor}>
                <IcChip/>
            </CardIcon>
            <Contents fullWidth spacing={4}>
                <Text size='title' fontWeight='medium' ellipsis >
                    {cardName}
                </Text>
                <Text color={colors.textSecondary} size='title'>
                    {cardNoSuffix}
                </Text>
            </Contents>
            <Link activityName='EasyCardManageBottomSheet'
                activityParams={{ cardId }}>
                <MoreVertical />
            </Link>
        </Container>
    );
}

const Container = styled(Row)`
    //padding: var(--spacing-4);
    padding: 16px;
`;

const CardIcon = styled.div<{
    backgroundColor: string;
}>`
    width: 90px;
    height: 60px;
    //border-radius: var(--radius-xs);
    border-radius: 4px;
    background-color: ${({ backgroundColor }) => backgroundColor};
    position: relative;
    display: flex;
    align-items: center;
`;

const IcChip = styled.div`
    //width: var(--spacing-5);
    //height: var(--spacing-3);
    width: 20px;
    height: 12px;
    background-color: #FFF2C0;
    //border-radius: var(--radius-xs);
    border-radius: 4px;
    left: 7px;
    position: absolute;
`;

const Contents = styled(Column)`
    flex: 1;
    overflow: hidden;
`;

export default EasyCardItem;
